import { BridgeApplication } from '../mockData/mockApplicationsGridData';
import { IncompleteGrid } from './components/IncompleteGrid';

export interface IncompleteProps {
    data: BridgeApplication[];
}

export const Incomplete = ({ data }: IncompleteProps) => {
    return (
        <div>
            <div style={{ paddingBottom: '8px', fontWeight: 600 }}>
                <i>Incomplete</i>
            </div>
            <div>
                <IncompleteGrid data={data} />
            </div>
        </div>
    );
};
